import { Routes, Route, useNavigate,useLocation } from "react-router-dom";
import Home from "./pages/Home";
import LoginPage from "./pages/Auth/LoginPage";
import SignupPage from "./pages/Auth/SignupPage";
import ForgotPasswordPage from "./pages/Auth/ForgotPasswordPage";
import VerifyEmailPage from "./pages/Auth/VerifyEmailPage";
import UpdatePasswordPage from "./pages/Auth/UpdatePasswordPage";
import PrivateRoute from "./components/common/PrivateRoute";
import Navbar from "./components/Dashboard/common/Navbar";
import Dashboard from "./pages/Dashboard/Dashboard";
import { useEffect } from "react";
import { getUserDetails } from "./services/oprations/authAPI";
import { useDispatch, useSelector } from "react-redux";
import ChatbotEmptyState from "./pages/Dashboard/ChatbotEmptyState";
import OpenRoute from "./components/common/OpenRoute";
import OpenAISettings from "./pages/Dashboard/OpenAISettings";
import AIAssistants from "./pages/Dashboard/AIAssistants";
import VectorStore from "./pages/Dashboard/VectorStore";
import AIPrograms from "./pages/Dashboard/AIPrograms";

/* Dashboard Pages */

import WebsiteAILauncher from "./pages/Dashboard/websiteAI/WebsiteAILauncher";
import CrmAi from "./pages/Dashboard/CRM-AI/CrmAi";
import Odoo from "./pages/Dashboard/CRM-AI/Odoo";
import ChatBot from "./pages/Dashboard/CRM-AI/ChatBot";
import SocailMedia from "./pages/Dashboard/SocialMedia/SocailMedia";


function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.profile);
  const location = useLocation();

const hideNavbarRoutes = [
  "/dashboard/crm-ai/odoo/chatbot",
];

const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      dispatch(getUserDetails()).then((success) => {
        if (!success) {
          navigate("/");
        }
      });
    }
  }, [dispatch]);

  useEffect(() => { }, [user?.image]);

  return (
    <Routes>
      {/* Open For ALL */}
      <Route path="/" element={<Home />} />

      {/* Open Route - for Only Non Logged in User */}
      <Route
        path="signup"
        element={
          <OpenRoute>
            <SignupPage />
          </OpenRoute>
        }
      />
      <Route
        path="login"
        element={
          <OpenRoute>
            <LoginPage />
          </OpenRoute>
        }
      />
      <Route
        path="verify-email"
        element={
          <OpenRoute>
            <VerifyEmailPage />
          </OpenRoute>
        }
      />
      <Route
        path="forget-password"
        element={
          <OpenRoute>
            <ForgotPasswordPage />
          </OpenRoute>
        }
      />
      <Route
        path="update-password/:token"
        element={
          <OpenRoute>
            <UpdatePasswordPage />
          </OpenRoute>
        }
      />

      {/* Protected Dashboard Routes */}
    <Route
      path="/dashboard"
      element={
        <PrivateRoute>
          <div className="flex flex-col min-h-screen">
            {!shouldHideNavbar && <Navbar />}

            <main className={`flex-1 ${!shouldHideNavbar ? "pt-20" : ""}`}>
              <Dashboard />
            </main>
          </div>
        </PrivateRoute>
      }
    >

        {/* Default dashboard */}
        <Route index element={<ChatbotEmptyState />} />

        {/* Feature pages */}
        {/* CRM */}
        <Route path="/dashboard/crm-ai" element={<CrmAi />} />
        <Route path="/dashboard/crm-ai/odoo" element={<Odoo />} />
        <Route path="/dashboard/crm-ai/odoo/chatbot" element={<ChatBot />} />

        {/* Socail Meadia */}
        <Route path="/dashboard/social-ai" element={<SocailMedia />} />

        {/* Website AI */}
        <Route
          path="/dashboard/website-ai"
          element={<WebsiteAILauncher />}
        />

        {/* Other Pages */}
        <Route path="openai-settings" element={<OpenAISettings />} />
        <Route path="ai-assistants" element={<AIAssistants />} />
        <Route path="vector-stores" element={<VectorStore />} />
        <Route path="ai-programs" element={<AIPrograms />} />

      </Route>
    </Routes>
  );
}

export default App;
